<template>
  <div class="not-found">
    <div class="no-content-img">
      <img src="@/assets/images/pub/404.png" alt="" />
    </div>
    <div class="no-content-text">
      哎呀,打不开网页了呢!
    </div>
  </div>
</template>
<style lang="less" scoped>
.no-content-img {
    width: 164px;
    height: 163px;
    margin-bottom: 22px;
    img {
        width: 100%;
        height: 100%;
    }
}
    .not-found {
        display: flex;
        width: 100%;
        height: calc(100vh - 165px);
        background-color: #f3f4f7;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: auto 0;
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        font-weight: normal;
        line-height: 24px;
        text-align: center;
        letter-spacing: 0px;

        /* 新灰阶/新灰阶5 */
        color: #909CAC;
    }
</style>
